// src/pages/NotFound.tsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/common/Header';
import Footer from '../components/common/Footer';
import Button from '../components/common/Button';
import useScrollToTop from '../hooks/hook';

const NotFound: React.FC = () => {
  useScrollToTop();
  const navigate = useNavigate();

  const handleHomeClick = () => {
    navigate('/');
  };

  return (
    <div className="l_container">
      <Header />
      <div className="l_notfound">
        <h1 className="notfound_title">404エラー</h1>
        <p className="notfound_page_desc">
          ページが見つかりませんでした。
        </p>
        <Button onClick={handleHomeClick} className="notfound-button" iconPosition="left"
          iconType="left"
          iconSize={30}>
          トップに戻る
        </Button>
      </div>
      <Footer />
    </div>
  );
};

export default NotFound;
